import { useSelector } from 'react-redux'
import {
    getReportActionsState,
    setReportActionsState,
} from '../../Redux/VisualUnits/visualUnitStateSlice'
import { RootState } from '../../Redux/store'
import ErrorBlock from '../ValidationsErrorBlock'
import { FoundationsConstants } from '../../FoundationsConstants'

export const ReportFailed = (props: {
    VisualUnitId: number
    allowEdit: boolean
    operationStatusMessage: string
    isExplore: boolean
    toggleIsExplore: Function
}) => {
    const { VisualUnitId, allowEdit, operationStatusMessage, toggleIsExplore, isExplore } = props
    
    const showVisualUnitParams = () => {
        toggleIsExplore()
    }

    return (
        <>
            <div
                style={{ opacity: 1 }}
                id={`dashboard_vu_data_${VisualUnitId}`}
            >
             <ErrorBlock highlightClass="fade-bg" customClass='vu_highlightclass'>
                <div className="padding-small" >
                    {operationStatusMessage}

                    {allowEdit && operationStatusMessage === FoundationsConstants.reportFailedOperationStatusMessage ?
                        <></>
                        // FP-11674- empty tag that means no fix it link should be displayed 
                        :
                        <div
                            id={'React_dashboard_vu_actions_' + VisualUnitId}
                            className="cursor-pointer float-right"
                            onClick={() => !isExplore ? showVisualUnitParams() : null} //onClick is only for not in explore mode
                        >
                            Fix it.
                        </div>
                    }
                </div>
            </ErrorBlock>
                 </div>
             </>
    )
}
